<template>
  <div class="page flex-col">
    <div class="section_1 flex-col">
      <div class="box_1 flex-row">
        <span class="text_11">面试时长：</span>
        <div class="block_2 flex-row">
          <span class="text_12">1小时</span>
          <img
            class="thumbnail_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng32bb5ffc73b63ed9396c4ca5c88708cf949f1f38de2bf548b59a76f324c084d7.png"
          />
        </div>
      </div>
    </div>
    <div class="box_23 flex-col">
      <div class="box_2 flex-col"></div>
      <div class="text-wrapper_1 flex-col"><span class="text_5">开始面试</span></div>
      <div class="box_3 flex-col">
        <div class="block_1 flex-col">
          <div class="text-wrapper_2 flex-col"><span class="text_6">你好！面试可以开始了吗</span></div>
        </div>
      </div>
      <div class="box_4 flex-col">
        <div class="box_24 flex-row justify-between">
          <span class="text_7">设置</span>
          <div class="image-wrapper_2 flex-col">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng5b8557aa5cd1d3d242a57174707ee895be082eb8bb725b046460306200cfeae9.png"
            />
          </div>
        </div>
        <div class="group_2 flex-col"></div>
        <div class="box_25 flex-row justify-between">
          <div class="section_4 flex-col"></div>
          <div class="block_3 flex-col">
            <div class="box_5 flex-row">
              <div class="text-wrapper_3 flex-col"><span class="text_8">虚拟背景</span></div>
              <span class="text_9">美颜</span>
              <span class="text_10">滤镜</span>
            </div>
            <div class="section_6 flex-row justify-end">
              <div class="box_7 flex-col">
                <img
                  class="thumbnail_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngaadd2b6845d4a4ab6eee6d4695660d7ad1522fe0648cc2e508c810f43d4c8f3d.png"
                />
                <div class="image-text_2 flex-row justify-between">
                  <span class="text-group_1">不使用</span>
                  <img
                    class="thumbnail_4"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng5a62b681c9a2fba3bd45053dd7ba7a6ba189fbe2e907c9f0195f9a9ea0e8f7e5.png"
                  />
                </div>
              </div>
              <div class="box_8 flex-col"></div>
              <div class="box_9 flex-col"></div>
              <div class="box_10 flex-col"></div>
            </div>
            <div class="section_7 flex-row justify-between">
              <div class="group_4 flex-col"></div>
              <div class="group_5 flex-col"></div>
              <div class="group_6 flex-col"></div>
              <div class="group_7 flex-col"></div>
            </div>
            <div class="section_8 flex-row justify-between">
              <div class="group_8 flex-col"></div>
              <div class="group_9 flex-col"></div>
              <div class="group_10 flex-col"></div>
              <div class="group_11 flex-col"></div>
            </div>
            <div class="section_9 flex-row justify-between">
              <div class="box_14 flex-col"></div>
              <div class="box_15 flex-col"></div>
              <div class="box_16 flex-col"></div>
              <div class="box_17 flex-col"></div>
            </div>
            <div class="section_10 flex-row justify-between">
              <div class="box_19 flex-col"></div>
              <div class="box_20 flex-col"></div>
              <div class="box_21 flex-col"></div>
              <div class="box_22 flex-col"></div>
            </div>
          </div>
        </div>
        <div class="box_26 flex-row justify-between">
          <div class="text-wrapper_4 flex-col"><span class="text_13">取消</span></div>
          <div class="text-wrapper_5 flex-col"><span class="text_14">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />